import {IS_TOUCH_DEVICE, initElements} from '../define/shared'
import screenfull from 'screenfull'

const DOUBLE_TAP_THRESHOLD = 300

export default function initMapLegendBlocks() {
    initElements('.wab.wab-mapLegend', initMapLegendBlock)
}

/**
 * @param {HTMLElement} root
 */
export function initMapLegendBlock(root) {
    const imgRootEl = root.querySelector('.b-image')
    const msgEl = imgRootEl.querySelector('.i-tapMsg')
    const scrollableEl = imgRootEl.querySelector('.i-scrollable')
    const scalableEl = imgRootEl.querySelector('.i-scalable')
    const zoomInBtn = imgRootEl.querySelector('.i-zoomInBtn')
    const zoomOutBtn = imgRootEl.querySelector('.i-zoomOutBtn')
    const fsBtn = imgRootEl.querySelector('.i-fsBtn')
    const dtDragger = getDtDragger()

    let ignoreMsg = false
    let prevTapTs = 0
    let msgTout = null
    let tapTout = null


    zoomOut()

    if (IS_TOUCH_DEVICE) {
        imgRootEl.classList.add('is--touchEnabled')
        imgRootEl.addEventListener('touchend', onClick)
    } else {
        imgRootEl.addEventListener('click', onClick)
    }

    zoomInBtn.addEventListener('click', () => !zoomInBtn.disabled && zoom())
    zoomOutBtn.addEventListener('click', () => !zoomOutBtn.disabled && zoom())
    if (!IS_TOUCH_DEVICE && screenfull.isEnabled) {
        fsBtn.addEventListener('click', toggleFs)

        screenfull.on('change', event => {
            if (event.target === root) {
                if (screenfull.isFullscreen) {
                    root.classList.add('is--fs')
                } else {
                    root.classList.remove('is--fs')
                }
            }
        })
    } else {
        fsBtn.style.display = 'none'
    }

    function toggleFs() {
        if (screenfull.isEnabled) {
            if (screenfull.isFullscreen) {
                screenfull.exit()
            } else {
                screenfull.request(root, {navigationUI: 'hide' })
            }
        }
    }

    function zoom() {
        hideMsg()
        isZoomedIn() ? zoomOut() : zoomIn()
    }

    function isZoomedIn() {
        return imgRootEl.classList.contains('is--zoomedIn')
    }

    function zoomOut() {
        imgRootEl.classList.remove('is--zoomedIn')
        zoomInBtn.removeAttribute('disabled')
        zoomOutBtn.setAttribute('disabled', 'disabled')
        dtDragger.pause()
    }

    function zoomIn() {
        imgRootEl.classList.add('is--zoomedIn')
        zoomInBtn.setAttribute('disabled', 'disabled')
        zoomOutBtn.removeAttribute('disabled')
        dtDragger.start()
        scrollableEl.scrollTo({
            top: scrollableEl.scrollHeight > scrollableEl.offsetHeight
                 ? (scrollableEl.scrollHeight - scrollableEl.offsetHeight) / 2
                 : 0,
            left: scrollableEl.scrollWidth > scrollableEl.offsetWidth
                 ? (scrollableEl.scrollWidth - scrollableEl.offsetWidth) / 2
                 : 0
        })
    }

    function onClick(event) {
        if (
            event.target === zoomInBtn ||
            event.target === zoomOutBtn ||
            event.target === fsBtn ||
            zoomInBtn.contains(event.target) ||
            zoomOutBtn.contains(event.target) ||
            fsBtn.contains(event.target)
        ) {
            return true
        }
        if (event.cancelable) {
            event.preventDefault()
        }
        if (tapTout) {
            window.clearTimeout(tapTout)
        }
        const ts = (new Date()).getTime()
        if (ts - prevTapTs < DOUBLE_TAP_THRESHOLD) {
            zoom()
        } else {
            if (event.type === 'touchend') {
                tapTout = setTimeout(() => {
                    showMsg()
                    window.clearTimeout(tapTout)
                }, DOUBLE_TAP_THRESHOLD)
            } else {
                showMsg()
            }
        }
        prevTapTs = ts
        // In case this tap is the end of scroll,
        // might show message on next non-move click
        ignoreMsg = false
    }

    function hideMsg() {
        msgEl.classList.remove('is--visible')
    }

    function showMsg(holdMs = 1000) {
        if (ignoreMsg || scrollableEl.scrollTop || scrollableEl.scrollLeft) {
            return
        }
        msgTout && window.clearInterval(msgTout)
        msgEl.classList.add('is--visible')
        msgTout = window.setTimeout(hideMsg, holdMs)
    }


    function getDtDragger() {
        let isRunning = false
        let pos = {
            top: 0,
            left: 0,
            x: 0,
            y: 0,
        }

        function onMouseDown(e) {
            pos = {
                // The current scroll
                left: scrollableEl.scrollLeft,
                top: scrollableEl.scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY,
            }

            window.addEventListener('mousemove', onMouseMove)
            window.addEventListener('mouseup', onMouseUp)
            imgRootEl.addEventListener('mouseleave', onMouseUp)

            // Change the cursor and prevent user from selecting the text
            scrollableEl.style.cursor = 'grabbing'
            scrollableEl.style.userSelect = 'none'
        }

        function onMouseMove(e) {
            // How far the mouse has been moved
            const dx = e.clientX - pos.x
            const dy = e.clientY - pos.y

            // Scroll the element
            scrollableEl.scrollTop = pos.top - dy
            scrollableEl.scrollLeft = pos.left - dx
        }

        function onMouseUp(e) {
            window.removeEventListener('mousemove', onMouseMove)
            window.removeEventListener('mouseup', onMouseUp)
            imgRootEl.removeEventListener('mouseleave', onMouseUp)
            scrollableEl.style.cursor = 'grab'
            scrollableEl.style.removeProperty('user-select')
        }

        return {
            isRunning() {
                return isRunning
            },
            start() {
                scrollableEl.style.cursor = 'grab'
                imgRootEl.addEventListener('mousedown', onMouseDown)
                isRunning = true
            },
            pause() {
                onMouseUp()
                scrollableEl.style.cursor = ''
                imgRootEl.removeEventListener('mousedown', onMouseDown)
                isRunning = false
            }
        }
    }
}
